// src/pages/Login.jsx
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import toast from 'react-hot-toast';
import SummaryApi from '../common/index';  // ← added this import
import ghruLogo from '../assets/oakyalogo.png';  // ← added this import

// Import images (adjust path if your folder structure is differen

const Login = () => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);

    try {
      const response = await fetch(SummaryApi.adminlogin.url, {
        method: SummaryApi.adminlogin.method,
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          user_name: username.trim(),
          password: password,
        }),
      });

      const result = await response.json();

      if (result.status === true) {
        sessionStorage.setItem("isLoggedIn", "true");
        sessionStorage.setItem("user", username);

        // Store all relevant fields from response
        if (result.member_type) {
          sessionStorage.setItem("member_type", result.member_type);
        }
        if (result.admin_id) {
          sessionStorage.setItem("admin_id", result.admin_id);
        }
        if (result.consultancy_name) {
          sessionStorage.setItem("consultancy_name", result.consultancy_name);
        }
        if (result.full_name) {
          sessionStorage.setItem("full_name", result.full_name);
        }
        if (result.consultancy_code) {
          sessionStorage.setItem("consultancy_code", result.consultancy_code);
        }
        if (result.mobile_number1) {
          sessionStorage.setItem("mobile_number1", result.mobile_number1);
        }

        toast.success("Login successful! Welcome back 👋", {
          duration: 3000,
          position: "top-center",
        });

        navigate("/admin", { replace: true });
      } else {
        const errMsg = result.message || "Invalid username or password";
        toast.error(errMsg);
        setError(errMsg);
      }
    } catch (err) {
      console.error("Login failed:", err);
      const fallback = "Something went wrong. Please try again.";
      toast.error(fallback);
      setError(fallback);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div 
      className="min-h-screen flex items-center justify-center bg-gradient-to-br from-indigo-50 via-white to-blue-50"
    >
      <div className="bg-white/95 backdrop-blur-sm p-10 rounded-2xl shadow-2xl w-full max-w-lg border border-gray-200/50">
        {/* Header with title + logo */}
        <div className="text-center mb-8">
          {ghruLogo ? (
            <img
              src={ghruLogo}
              alt="G H Raisoni University Logo"
              className="mx-auto h-24 w-auto object-contain"
            />
          ) : (
            <div className="mx-auto h-20 w-48 bg-gray-200 rounded flex items-center justify-center text-gray-500">
              Logo not found
            </div>
          )}
                    <h2 className="text-2xl font-bold text-indigo-700 mb-4 mt-4">
    Oakya Admissions CRM <br/>
     Login
          </h2>
        </div>

        <form onSubmit={handleLogin}>
          {/* Username */}
          <div className="mb-6">
            <label 
              htmlFor="username" 
              className="block text-gray-800 font-medium mb-2 text-lg"
            >
              Username
            </label>
            <input
              type="text"
              id="username"
              value={username}
              onChange={(e) => setUsername(e.target.value.trim())}
              className="w-full px-5 py-3.5 border border-gray-300 rounded-xl focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 text-lg bg-white/80"
              placeholder="Enter username"
              required
              autoFocus
            />
          </div>

          {/* Password */}
          <div className="mb-8">
            <label 
              htmlFor="password" 
              className="block text-gray-800 font-medium mb-2 text-lg"
            >
              Password
            </label>
            <div className="relative">
              <input
                type={showPassword ? "text" : "password"}
                id="password"
                autoComplete="off"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="w-full px-5 py-3.5 pr-14 border border-gray-300 rounded-xl focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 text-lg bg-white/80"
                placeholder="Enter password"
                required
              />
              <button
                type="button"
                onClick={() => setShowPassword(!showPassword)}
                className="absolute inset-y-0 right-4 flex items-center text-gray-600 hover:text-indigo-700 transition-colors"
              >
                {showPassword ? (
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13.875 18.825A10.05 10.05 0 0112 19c-5 0-9-4-9-9a8.96 8.96 0 012.225-5.625M15 15l6 6m-6-6L3 3" />
                  </svg>
                ) : (
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M2.458 12C3.732 7.943 7.523 5 12 5c4.477 0 8.268 2.943 9.542 7-1.274 4.057-5.065 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
                  </svg>
                )}
              </button>
            </div>
          </div>

          {error && (
            <div className="mb-6 text-red-600 text-center font-medium text-base">
              {error}
            </div>
          )}

          <button
            type="submit"
            disabled={loading}
            className={`w-full py-3.5 px-6 rounded-xl text-white font-semibold text-lg transition-all duration-300 shadow-md
              ${loading 
                ? 'bg-gray-400 cursor-not-allowed shadow-none' 
                : 'bg-gradient-to-r from-purple-600 to-yellow-500 hover:from-purple-700 hover:to-yellow-400 active:from-purple-800 active:to-yellow-600 hover:shadow-lg hover:shadow-purple-400/50 hover:scale-[1.02]'
              }`}
          >
            {loading ? 'Logging in...' : 'Login'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default Login;